import React, { memo } from 'react';
import Main from '@components/pages/main';

type Props = {};

const MainPage: React.FC<Props> = ({}) => {
  return <Main />;
};

export default memo(MainPage);
